import React, { useState, useEffect, useRef } from 'react';
import getCategories from '../../services/getCategories';
import Sugerencias from '../sugerencias/Sugerencias';

export default function BusquedaForm({ query, category, onQueryChange, onCategoryChange, onSearch, token, setQuery, retryCount,
  setToken,
  setErrorService,
  setRetrySearch,
  setRetryCount,
  sessionId,
  errorService,
  isMobile,
  setData }) {
  const [text, setText] = useState(query);
  const [textNew, setTextNew] = useState();
  const [categories, setCategories] = useState();
  const [showSugerencias, setShowSugerencias] = useState(false);
  const inputRef = useRef(null);
  const [hasFocus, setHasFocus] = useState(false);
  const handleFocus = () => setHasFocus(true);
  const handleBlur = () => setHasFocus(false);
  const [listaSugerencias, setListaSugerencias] = useState([]);    
  const [selectedIndex, setSelectedIndex] = useState(-1);

  // obtiene el json con el listado de categorias
  useEffect(() => {
    getCategories()
      .then((data) => {
        setCategories(data);
      })
      .catch((error) => {
        console.error("Error al obtener las categorias.", error);
      });
  }, []);

  // guarda el valor de lo que tiene el input de busqueda
  const handleQueryChange = (event) => {
    setText(event.target.value);

    if (event.target.value === "") {
      handleReset();
    }
  };

  // realiza la busqueda al presionar enter
  const handleKeyPress = (event) => {
    let key = event.key || event.which || event.keyCode;
    if ((key === 'Enter' || key === 'Go' || key === 13) && selectedIndex === -1) {

        if(String(textNew).length > 0 && textNew){
          onQueryChange(textNew);
        }else {
          onQueryChange(text);
        }

      setShowSugerencias(false);
    }
        // Verifica si se ha presionado la tecla de borrar (Backspace) o cualquier otra tecla
    if ((key === 'Backspace') && (key !== 'Enter' && key !== 'Go' && key !== 13)) {
        setSelectedIndex(-1); // Restablece el índice seleccionado
        setTextNew("");
    }
  };

  // revisa si la longitud de la palabra es correcta para mostrar las sugerencias
  useEffect(() => {
    if (text && text.length >= 3) {
      setShowSugerencias(true);
    }
  }, [text])

  // activa funcion realizar busqueda con boton
  const handleSearch = () => {
    onQueryChange(text);
    setShowSugerencias(false);
  }

  // si existe query lo asigna al value del input search
  useEffect(() => {
    if (query) {
      setText(query);
    }
  }, [query])


  const handleReset = () => {
    setText("");
    setTextNew("");
    onQueryChange("");
    setData(null);
    setListaSugerencias([]);
    setSelectedIndex(-1);
  }

  // detecta el focus y blur del input para mostrar el listado de sugerencias
  useEffect(() => {
    const inputElement = inputRef.current;

    if (inputElement) {
      inputElement.addEventListener('focus', handleFocus);
      inputElement.addEventListener('blur', handleBlur);
    }

    // Limpiar eventos al desmontar el componente
    return () => {
      if (inputElement) {
        inputElement.removeEventListener('focus', handleFocus);
        inputElement.removeEventListener('blur', handleBlur);
      }
    };
  }, []);

  return (
    <>
      <div className="search-container">
        <input
          type="text"
          id="query"
          value={text}
          onChange={handleQueryChange}
          onKeyPress={handleKeyPress}
          onKeyDown={handleKeyPress}
          placeholder="Buscar..."
          className="search-input"
          autoComplete='off'
          ref={inputRef}
          style={{ 
            'fontSize': '16px',  
            'WebkitOverflowScrolling': 'touch', 
            'overflowX': 'auto', 
            'whiteSpace': 'normal',  
            'textOverflow': 'clip'
          }}
        />
        <button id="buscarBtn" onClick={handleSearch} className="search-button">
          <span className="item-search-unotv"></span>
        </button>

        {/* Botón para resetear la selección */}
        <button
          type="button"
          className="reset-button"
          onClick={() => handleReset()}
        >
          
        </button>
      </div>

      <div className="tags-container">
        {categories && categories.map((cat, index) => (
          <label key={cat.id + cat.value}>
            <input
              type="radio"
              name="category"
              value={cat.value}
              // checked={String(category).trim() === String(cat.value).trim()}
              checked={
                (index === 0 && cat.value.trim() === "" && category.trim() === "") ||
                (index !== 0 && String(category).trim() === String(cat.value).trim())
              }
              onChange={onCategoryChange}
            />
            <span className="tag-label">{cat.label}</span>
          </label>
        ))}
      </div>

      {text && String(text).trim().length >= 3 && showSugerencias && <Sugerencias 
        palabra={text} setText={setText} 
        setTextNew={setTextNew}
        setShowSugerencias={setShowSugerencias} 
        inputRef={inputRef} token={token} 
        hasFocus={hasFocus} 
        setQuery={setQuery} 
        retryCount={retryCount}
        setToken={setToken}
        setErrorService={setErrorService}
        setRetrySearch={setRetrySearch}
        setRetryCount={setRetryCount}
        sessionId={sessionId}
        errorService={errorService}
        category={category}
        isMobile={isMobile}
        onQueryChange={onQueryChange}
        listaSugerencias={listaSugerencias}
        setListaSugerencias={setListaSugerencias}
        setSelectedIndex={setSelectedIndex}
        selectedIndex={selectedIndex}
      />}
    </>
  );
}

